"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformArguments = void 0;
function transformArguments(index) {
    return ['FT.SYNDUMP', index];
}
exports.transformArguments = transformArguments;
